// extracted by mini-css-extract-plugin
module.exports = {"logo":"publicAppLogo_logo__38lmq"};